import type { ReactNode } from 'react';
import styles from './S3FieldList.module.css';

/** One label/value pair rendered as a <dt>/<dd> in the field list. */
export interface Field {
  label: string;
  value: ReactNode;
  /** Render the value monospaced (ARNs, ids, keys). */
  mono?: boolean;
}

/**
 * Metadata field list for S3 detail/read pages — a `<dl>` grid of label/value
 * rows. Wrap in `<Card flat><CardBody>` for the house-style card treatment.
 */
export function S3FieldList({ fields }: { fields: Field[] }) {
  return (
    <dl className={styles.fieldList}>
      {fields.map((f) => (
        <div key={f.label} className={styles.fieldRow}>
          <dt className={styles.fieldLabel}>{f.label}</dt>
          <dd className={`${styles.fieldValue}${f.mono ? ` ${styles.mono}` : ''}`}>
            {f.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
